const GlobeSVG = ({ isDark }) => {
  const fillColor = isDark ? '#e6e6e6' : 'black';

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34" fill="none">
      <g clipPath="url(#clip0_8_21361)">
        <path
          d="M17.5312 0.973267V8.52658C19.4852 8.47611 21.3706 8.15152 23.1482 7.58361C21.7717 4.9927 19.8486 2.73861 17.5312 0.973267Z"
          fill={fillColor}
        />
        <path
          d="M24.6293 8.18552C25.797 10.7297 26.4759 13.5432 26.5487 16.5086H33.9862C33.856 12.2756 32.1821 8.43256 29.503 5.52502C28.0128 6.61196 26.3781 7.51243 24.6293 8.18552Z"
          fill={fillColor}
        />
        <path
          d="M24.1607 7.22819C25.805 6.60397 27.3429 5.76832 28.7497 4.76001C25.9457 2.07666 22.227 0.344256 18.1061 0.0791626C20.6173 1.97732 22.694 4.41629 24.1607 7.22819Z"
          fill={fillColor}
        />
        <path
          d="M26.5492 17.5711C26.4679 20.8893 25.627 24.0173 24.1915 26.7904C25.8666 27.3929 27.4412 28.2035 28.891 29.1853C31.9244 26.2145 33.8465 22.1181 33.9867 17.5716L26.5492 17.5711Z"
          fill={fillColor}
        />
        <path
          d="M25.4867 17.5711H17.5312V25.5531C19.4884 25.6015 21.3796 25.9101 23.1705 26.4525C24.5778 23.7894 25.4033 20.7735 25.4867 17.5711Z"
          fill={fillColor}
        />
        <path
          d="M16.4688 17.5711H8.51331C8.59618 20.7729 9.42228 23.7894 10.829 26.4531C12.6199 25.9107 14.5117 25.6015 16.4682 25.5537L16.4688 17.5711Z"
          fill={fillColor}
        />
        <path
          d="M17.5312 33.1064C19.5734 31.5504 21.31 29.6166 22.636 27.4056C21.0093 26.9333 19.2987 26.6618 17.5312 26.6161V33.1064Z"
          fill={fillColor}
        />
        <path
          d="M17.5312 16.5086H25.4867C25.4129 13.6685 24.7552 10.9751 23.6252 8.54358C21.7 9.17524 19.6547 9.53648 17.5312 9.58908V16.5086Z"
          fill={fillColor}
        />
        <path
          d="M16.4688 9.58908C14.3454 9.53648 12.2995 9.17524 10.3748 8.54358C9.24484 10.9751 8.58715 13.6685 8.51331 16.5086H16.4688V9.58908Z"
          fill={fillColor}
        />
        <path
          d="M9.8393 7.22819C11.3061 4.41629 13.3827 1.97679 15.894 0.0791626C11.7731 0.344256 8.0543 2.07666 5.25037 4.76054C6.65659 5.76885 8.19562 6.60451 9.8393 7.22819Z"
          fill={fillColor}
        />
        <path
          d="M16.4687 33.1064V26.6161C14.7013 26.6618 12.9901 26.9338 11.364 27.4056C12.69 29.6166 14.4266 31.5515 16.4687 33.1064Z"
          fill={fillColor}
        />
        <path
          d="M23.6719 27.7366C22.2466 30.1761 20.3511 32.3048 18.1066 34C21.9082 33.7556 25.3677 32.2623 28.0824 29.9248C26.7181 29.027 25.2407 28.2859 23.6719 27.7366Z"
          fill={fillColor}
        />
        <path
          d="M10.328 27.736C8.75922 28.2853 7.28182 29.0264 5.9165 29.9242C8.63119 32.2617 12.0912 33.7556 15.8928 34C13.6488 32.3048 11.7533 30.1761 10.328 27.736Z"
          fill={fillColor}
        />
        <path
          d="M7.45078 17.5711H0.0132751C0.153525 22.1181 2.07559 26.2145 5.10903 29.1848C6.55881 28.203 8.1329 27.3923 9.80846 26.7899C8.37356 24.0173 7.53259 20.8893 7.45078 17.5711Z"
          fill={fillColor}
        />
        <path
          d="M16.4688 0.973267C14.1515 2.73808 12.2283 4.9927 10.8519 7.58308C12.63 8.15098 14.5154 8.47611 16.4688 8.52605V0.973267Z"
          fill={fillColor}
        />
        <path
          d="M7.45078 16.5086C7.52409 13.5432 8.2025 10.7297 9.37018 8.18552C7.62131 7.5119 5.98665 6.61196 4.49649 5.52502C1.8174 8.43256 0.143431 12.2756 0.0132751 16.5086H7.45078Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_8_21361">
          <rect width="34" height="34" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default GlobeSVG;
